howspace.components.otpInput = (() => {
    'use strict';

    const getPin = otpInput => {
        return otpInput.find('.digit').toArray().map(digit => $(digit).val()).join('').trim();
    };

    const validate = otpInput => {
        howspace.form.clearInvalidField(otpInput);
        real.button.loading(otpInput.find('.submit-btn'), otpInput);

        const urlParams = new URLSearchParams(window.location.search);
        const path = urlParams.get('uri');

        const dataPayload = {
            email: $(otpInput.data('email-elem')).val(),
            pin: getPin(otpInput),
            path: path
        };

        real.ajax.json(real.baseUri + otpInput.data('url'), {
            type : 'POST',
            data : JSON.stringify(dataPayload),
            waitForWebsocket : false,
            showErrorNotification : false,
            logError : response => {
                return !(response.status === 400 || response.status === 403);
            },
            success : response => {
                if (response.location) {
                    window.location = response.location;
                }
            },
            error : response => {
                real.button.reset(otpInput.find('.submit-btn'), otpInput);

                real.ajax.loopErrors(response, function(error) {
                    howspace.form.markInvalidField(otpInput, error.message);
                    otpInput.trigger('focus');
                });
            }
        });
    };

    const handlePaste = (otpInput, pin) => {
        otpInput.find('.digit').each((i, digit) => {
            $(digit).val(pin.charAt(i));
        });

        validate(otpInput);
    };

    const handleOtpChange = e => {
        const otpInput = $(e.target).closest('.howspace-form-otp-input');
        const pin = e.target.value;
        if (pin.length !== otpInput.data('length')) {
            return;
        }

        e.preventDefault();

        handlePaste(otpInput, pin);
    };

    const handleOtpPaste = e => {
        const otpInput = $(e.target).closest('.howspace-form-otp-input');
        const pin = real.getClipboardText(e).trim();
        if (pin.length !== otpInput.data('length')) {
            return;
        }

        e.preventDefault();

        handlePaste(otpInput, pin);
    };

    const handleDigitInput = e => {
        const otpInput = $(e.target).closest('.howspace-form-otp-input');

        howspace.form.clearInvalidField(otpInput);

        if (getPin(otpInput).length === otpInput.data('length')) {
            otpInput.find('.submit-btn').prop('disabled', false);
        } else {
            otpInput.find('.submit-btn').prop('disabled', true);
        }

        const input = $(e.target);
        const length = input.val().length;

        if (length === 1) {
            const nextInput = input.closest('label').next().find('input');
            if (nextInput.length === 0) {
                validate(otpInput);
            } else {
                nextInput.trigger('focus');
            }
        } else if (length > 1) {
            input.val(input.val().slice(0, 1));
        }
    };

    const handleDigitKeydown = e => {
        const input = $(e.target);
        const otpInput = $(e.target).closest('.howspace-form-otp-input');
        const key = e.key;

        if (key === 'ArrowUp' || key === 'ArrowDown') {
            e.preventDefault();
            return;
        }

        if (key === 'Backspace' && input.val().length === 0) {
            input.closest('label').prev().find('input').trigger('focus');
        }

        if (key === 'Enter') {
            validate(otpInput);
        }
    };

    const handleDigitKeypress = e => {
        function isNumeric(charValue) {
            return '0123456789'.indexOf(charValue) > -1;
        }
        if ((e.key.length === 1) && !isNumeric(e.key)) {
            e.preventDefault();
        }
    };

    const handleDigitFocus = e => {
        $(e.target).trigger('select');
    };

    const handleSubmit = e => {
        const otpInput = $(e.target).closest('.howspace-form-otp-input');
        validate(otpInput);
    };

    const handleFocus = e => {
        const otpInput = $(e.target);
        otpInput.find('.digit').first().trigger('select');
    };

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-form-otp-input:not(.howspace-form-otp-input-initialized)').each(function () {
                const otpInput = $(this);
                otpInput.addClass('howspace-form-otp-input-initialized');

                const digits = otpInput.find('.digit');
                otpInput.on('focus', handleFocus);
                otpInput.find('input[autocomplete="one-time-code"]').on('change', handleOtpChange);
                otpInput.find('.digit').on('paste', handleOtpPaste);
                digits.on('input', handleDigitInput);
                digits.on('keydown', handleDigitKeydown);
                digits.on('keypress', handleDigitKeypress);
                digits.on('focus', handleDigitFocus);
                otpInput.find('.submit-btn').on('click', handleSubmit);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-form-otp-input.howspace-form-otp-input-initialized').each(function () {
                const otpInput = $(this);
                otpInput.removeClass('howspace-form-otp-input-initialized');

                const digits = otpInput.find('.digit');
                otpInput.off('focus', handleFocus);
                otpInput.find('input[autocomplete="one-time-code"]').off('change', handleOtpChange);
                otpInput.find('.digit').off('paste', handleOtpPaste);
                digits.off('input', handleDigitInput);
                digits.off('keydown', handleDigitKeydown);
                digits.off('keypress', handleDigitKeypress)
                digits.off('focus', handleDigitFocus);
                otpInput.find('.submit-btn').off('click', handleSubmit);
            });
        },
        reset: otpInput => {
            otpInput.find('.digit').val('');
            otpInput.find('.submit-btn').prop('disabled', true);
            howspace.form.clearInvalidField(otpInput);
        }
    };
})();
